import React from 'react';
import { FormNumber, Fieldset } from '~/components/FormControl';
import { Form, Col } from 'react-bootstrap';

function Point() {
    return (
        <Col sm={6}>
            <Fieldset>
                <Fieldset.Legend>Point:</Fieldset.Legend>
                <Form.Row>
                    <FormNumber
                        name={'pointToCompare'}
                        sm={3}
                    />
                    <FormNumber
                        name={'pointToPay'}
                        sm={3}
                    />
                    <FormNumber
                        name={'pointGained'}
                        sm={2}
                    />
                    <FormNumber
                        name={'pointWon'}
                        sm={2}
                    />
                    <FormNumber
                        name={'pointLost'}
                        sm={2}
                    />
                </Form.Row>
            </Fieldset>
        </Col>
    );
}

export default Point;
